import BarChartIcon from "@mui/icons-material/BarChart";
import {
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useState } from "react";

import DoughnutChart from "~/components/common/charts/DoughnutChart";
import useChartData from "~/components/command/hooks/useChartData";

import { LocalCalendarBlock, LocalShift, LocalVisit } from "~/hooks/visitDragDropReducer";

// Register the chart components
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

type Props = {
  localVisits: LocalVisit[];
  localShifts: LocalShift[];
  localCalendarBlocks: LocalCalendarBlock[];
  loading: boolean;
}

const CommandCenterStats = ({ localVisits, localShifts, localCalendarBlocks, loading }: Props) => {
  const [showStats, setShowStats] = useState<HTMLElement | null>(null);

  const {
    chartData,
    providerUtilization,
    visitChartData,
    totalVisits,
    cancellationChartData,
    cancellationRate,
  } = useChartData(localVisits, localShifts, localCalendarBlocks);

  return <>
    <IconButton
      onClick={(e) => showStats ? setShowStats(null) : setShowStats(e.currentTarget)}
      color="primary"
      aria-label={showStats ? "Hide Stats" : "Show Stats"}
      sx={{ marginRight: 2 }}
    >
      <BarChartIcon fontSize="large" />
    </IconButton>

    <Popover
      open={!!showStats}
      anchorEl={showStats}
      onClose={() => setShowStats(null)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <Grid container sx={{ width: "75vw", p: 2 }} spacing={2}>
        <Grid size={4}>
          <Typography variant="h6" sx={{ textAlign: "center", width: "100%", marginBottom: 2 }}>
            Provider Utilization
          </Typography>
          <DoughnutChart
            data={chartData}
            loading={loading}
            centerText={`${providerUtilization}%`}
            sx={{
              maxHeight: "calc(100% - 3.5rem)",
            }}
          />
        </Grid>
        <Grid size={4} sx={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", borderRadius: "8px", p: 2}}>
          <Typography variant="h6" sx={{ textAlign: "center", width: "100%", marginBottom: 2 }}>
            Visit Volume
          </Typography>
          <DoughnutChart
            sx={{
              maxHeight: "calc(100% - 4.5rem)",
            }}
            data={visitChartData}
            centerText={`${totalVisits}`}
            loading={loading}
          />
        </Grid>
        <Grid size={4}>
          <Typography variant="h6" sx={{ textAlign: "center", width: "100%", marginBottom: 2 }}>
            Cancellation Rate
          </Typography>
          <DoughnutChart
            data={cancellationChartData}
            centerText={`${cancellationRate}%`}
            loading={loading}
            sx={{
              maxHeight: "calc(100% - 3.5rem)",
            }}
          />
        </Grid>
      </Grid>
    </Popover>
  </>;
}

export default CommandCenterStats
